import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import './payment-method.scss';
import {useHistory, useParams} from 'react-router-dom';

const PaymentMethod = () => {
  const history = useHistory();
  const {branchId, orderId} = useParams();

  return (
    <div className={ 'payment-method' }>
      <div className={ 'list-label' }>Choose Payment Method</div>
      <div className={ 'methods-list' }>
        <div
          className={ 'method credit-card' }
          onClick={ () => {
            history.push('credit-card');
          } }
        >
          Credit Card
        </div>
      </div>

      <div
        className={ 'btn back' }
        onClick={ () => {
          history.goBack();
        } }
      >
        Back
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  // const {
  //   branchInfo
  // } = state;

  return {
    // branchInfo
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {},
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethod);

